import * as React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton

} from '@mui/material';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import { driveBase } from '../config';
import { renovarUrlArquivo } from '../services/arquivos';

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const DialogoVisualizador = ({ file, open, onClose }) => {
  const [url, setUrl] = React.useState('');
  const [erro, setErro] = React.useState('');

  React.useEffect(() => {
    let ativo = true;
    if (!open || !file) {
      setUrl('');
      setErro('');
      return () => { ativo = false; };
    }
    setUrl('');
    setErro('');
    renovarUrlArquivo(file)
      .then((novaUrl) => ativo && setUrl(driveBase + novaUrl))
      .catch(() => ativo && setErro('Não foi possível carregar o arquivo.'));
    return () => { ativo = false; };
  }, [file, open]);

  const content = () => {
    if (file) {
      if (file.mimeType === 'application/pdf' ||
        file.mimeType === 'text/html' ||
        file.mimeType=='text/csv' ||
        file.mimeType === 'application/msword' ||
        file.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.mimeType === 'application/vnd.ms-excel' ||
        file.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.mimeType === 'application/vnd.ms-powerpoint' ||
        file.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        return (
          <iframe src={url} title={file.fileName || 'Arquivo'} type={file.mimeType} width="100%" height="600px" />
        );
      } else if (
        file.mimeType=='image/jpeg' ||
        file.mimeType=='image/jpg' ||
        file.mimeType=='image/png' ||
        file.mimeType=='image/gif' ||
        file.mimeType=='image/bmp' ||
        file.mimeType=='image/webp') {
        return (
          <img src={url} alt={file.fileName || 'Arquivo'} className="img-responsive" />
        );
      } else if (
        file.mimeType=='video/mp4') {
        return (
          <video controls width="100%" height="600px">
            <source src={url} type={file.mimeType} />
            Seu navegador não suporta o elemento de vídeo.
          </video>
        );
      }
    }

    return '';
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth={true}>
      <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
        {file?.fileName}
      </BootstrapDialogTitle>
      <DialogContent className="file-viewer">
        {erro || (url ? content() : '')}
      </DialogContent>
    </Dialog>
  );
};

export default DialogoVisualizador;
